import { Button, Dialog, DialogActions, DialogContent } from "@mui/material";
import { useContext, useRef, useState } from "react";
import { UsinasContext } from "../context/UsinasContextProvider";
import { DialogHeader } from "../../../auth/components/PasswordRecoveryModal";
import { ConfirmationModal } from "../../../main/components/ConfirmationModal";
import { usinasApi } from "../../../services/api";
// import { ErrorModal } from "../../../main/components/ErrorModal";
import { ActionAlert } from "../../../main/components/alerts/ActionAlert";
import { UsinaLocationEditForm } from "./UsinaLocationEditForm";
import { Location } from "../types";

export function EditUsinaLocationModal(props: {
  open: boolean;
  setOpen: (open: boolean) => void;
}) {
  const { usina, setUsina } = useContext(UsinasContext);

  const { open, setOpen } = props;
  const [newLocation, setNewLocation] = useState<Location>();
  const [openEditConfirmationModal, setOpenEditConfirmationModal] =
    useState(false);
  const [openErrorModal, setOpenErrorModal] = useState(false);
  const [openSuccessModal, setOpenSuccessModal] = useState(false);
  const [canEdit, setCanEdit] = useState(false);
  const usinaId = usina && "usinaIds" in usina ? usina.usinaIds.id : "";
  const onClose = () => setOpen(false);

  const formRef = useRef<HTMLFormElement | null>(null);
  const handleFormSubmit = async () => {
    if (formRef.current) formRef.current.submitForm();
  };
  return (
    <>
      <Dialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        maxWidth="sm"
      >
        <DialogHeader id="customized-dialog-title" onClose={onClose}>
          Atualizar Localização da Usina
        </DialogHeader>
        <DialogContent
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            overflowY: "auto",
          }}
          dividers
        >
          <UsinaLocationEditForm
            open={open}
            setCanEdit={setCanEdit}
            setNewLocation={setNewLocation}
            setOpenConfirmLocationEditModal={setOpenEditConfirmationModal}
            ref={formRef}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Fechar</Button>
          <Button
            disabled={!canEdit}
            variant="contained"
            color="primary"
            onClick={handleFormSubmit}
          >
            Atualizar Localização
          </Button>
        </DialogActions>
      </Dialog>

      <ConfirmationModal
        open={openEditConfirmationModal}
        setOpen={setOpenEditConfirmationModal}
        title="Atualizar localização da Usina"
        contentText="Deseja confirmar a atualização da localização da Usina?"
        onConfirm={async () => {
          if (usinaId && newLocation) {
            await usinasApi.patchUsinaLocation(usinaId, newLocation);
            const updatedUsina = await usinasApi.getUsina(usinaId);
            setUsina(updatedUsina);
          }
        }}
        setOpenErrorModal={setOpenErrorModal}
        setOpenSuccessModal={setOpenSuccessModal}
      />
      <ActionAlert
        message="A localização da Usina foi atualizada com sucesso!"
        severity="success"
        open={openSuccessModal}
        setOpen={setOpenSuccessModal}
        onClose={() => {
          setOpen(false);
        }}
      />
      <ActionAlert
        message="Ocorreu um erro ao editar a localização da Usina! Tente novamente mais tarde."
        severity="error"
        open={openErrorModal}
        setOpen={setOpenErrorModal}
        onClose={() => {
          setOpen(false);
        }}
      />
      {/* <SuccessModal
        open={openSuccessModal}
        setOpen={setOpenSuccessModal}
        title="Localização da Usina atualizada com Sucesso!"
        contentText="A localização da Usina foi atualizada com sucesso!"
        onClose={() => {
          setOpen(false);
        }}
      />
      <ErrorModal
        open={openErrorModal}
        setOpen={setOpenErrorModal}
        title="Erro ao editar a localização da Usina!"
        contentText="Ocorreu um erro ao editar a localização da Usina! Tente novamente mais tarde."
        onClose={() => {
          setOpen(false);
        }}
      /> */}
    </>
  );
}
